<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select
              v-model="searchForm.nursinghomeId"
              style="width: 100%"
              placeholder="服务网点"
              @change="nursinghomeIdChange"
            >
              <el-option
                v-for="item in nursinghomeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="老人姓名" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="老人姓名"
              maxlength="16"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="身份证号" prop="idNumber">
            <el-input
              clearable
              v-model="searchForm.idNumber"
              placeholder="身份证号"
              maxlength="30"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" style="width: 100%" placeholder="状态">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" v-if="permissionList.addBtn" size="small" @click="addCardForm"> 新 增</el-button>
      </template>

      <template slot-scope="scope" slot="menu">
        <el-button v-if="scope.row.status!=0&&permissionList.chargeBtn" type="text" size="small" @click="recharge(scope.row)">充值</el-button>
        <el-button type="text"  v-if="permissionList.billsearchBtn" size="small" @click="orderPage(scope.row)">账单查询</el-button>
        <el-button v-if="scope.row.status!=0&&permissionList.logoutBtn" type="text" size="small" @click="logout(scope.row)">注销</el-button>
      </template>
    </avue-crud>
    <hr-dialog
      title="充值"
      :allowFull="false"
      width="60%"
   
      :visible.sync="rechargeFormVisible"
    >
      <template slot="body">
        <rechargeCardForm
          :nursinghomeId="searchForm.nursinghomeId"
          :row="formRow"
          @success="recordSuccess"
          @cancle="recordCancle"
          v-if="rechargeFormVisible"
        ></rechargeCardForm>
      </template>
    </hr-dialog>
   
    <hr-dialog
      title="新增"
      :allowFull="false"
      width="60%"
      @close="closeAddOldManDialog"
      :visible.sync="cardFormVisible"
    >
      <template slot="body">
        <cardForm
          :nursinghomeId="searchForm.nursinghomeId"
          :row="formRow"
          @success="recordSuccess"
          @cancle="recordCancle"
          v-if="cardFormVisible"
        ></cardForm>
      </template>
    </hr-dialog>

    <hr-dialog
      title="账单查询"
      :allowFull="false"
      width="60%"
      @close="closeAddOldManDialog"
      :visible.sync="orderPageVisible"
    >
      <template slot="body">
        <orderSearch
        @success="recordSuccess"
          :row="formRow"
          @cancle="recordCancle"
          v-if="orderPageVisible"
        ></orderSearch>
      </template>
    </hr-dialog>
  </basic-container>
</template>
<script>
import { getNursinghomePage, getNursinghome } from '../api/serveItemManage.js';
import { smartcardpage,smartcardlogout } from '@/api/nursingHome/nursingCard';
import searchFromShow from '@/components/search-form-show/index';
import cardForm from './cardForm.vue';
import orderSearch from './orderSearch.vue';
import rechargeCardForm from './rechargeCardForm.vue';
import { getDictionary } from '@/api/common.js';

import { removeStore, getStore } from '@/util/store';
import { mapGetters } from 'vuex';
export default {
  components: { searchFromShow, cardForm,rechargeCardForm,orderSearch },
  data() {
    return {
      cardFormVisible: false,
      editVisible: false,
      formModel: 'add',
    
      orderPageVisible: false,
      rechargeFormVisible: false,
      formRow:{},
      searchForm: {
        nursinghomeId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },

      nursinghomeIdList: [],
      statusList: [
        {
          dictValue: '注销',
          dictKey: 0,
        },
        {
          dictValue: '正常',
          dictKey: 1,
        },
      ],
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '卡号',
            prop: 'cardNo',
          },

          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '身份证',
            prop: 'idNumber',
          },
          {
            label: '性别',
            prop: 'sex',
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            dicUrl: '/api/nursing/getNursinghome',
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '余额',
            prop: 'balance',
          },
          {
            type: 'select',
            dataType: 'number',
            label: '状态',
            prop: 'status',
            dicData: [
              {
                dictValue: '注销',
                dictKey: 0,
              },
              {
                dictValue: '正常',
                dictKey: 1,
              },
            ],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      sexList: [],
      politicList: [],
      politicalFeaturesList: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        chargeBtn: this.vaildData(this.permission.nursingCard_charge, false),
        addBtn: this.vaildData(this.permission.nursingCard_add, false),
        billsearchBtn: this.vaildData(this.permission.nursingCard_billsearch, false),
        logoutBtn: this.vaildData(this.permission.nursingCard_logout, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
    let self = this;
    self.$refs.crud.doLayout();
    window.onresize = () => {
      self.$refs.crud.doLayout();
    };
  },
  activated() {
    console.log('activated=======================');
    this.$refs.crud.doLayout();
  },
  methods: {
    orderPage(row) {
      this.formRow = row
      this.orderPageVisible= true
    },
    addCardForm() {
      this.cardFormVisible = true;
    },
    recharge(row){
      this.formRow = row
      this.rechargeFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },
    logout(row) {
      this.$confirm('是否确认注销该一卡通账户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          smartcardlogout(row).then((re) => {
            this.$message.success('注销成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          basicInforRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },

    editRecord(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.nursingFormVisible = true;
    },
    viewFun(row) {
      this.cardFormVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.cardFormVisible= false
      this.orderPageVisible= false
      this.rechargeFormVisible= false
    },
    recordSuccess() {
      this.cardFormVisible= false
      this.orderPageVisible= false
      this.rechargeFormVisible= false
     
      this.onLoad();
    },
    viewRecord(row) {
      this.alarmRuleTittle = '查看';
      this.rowInfo = row;

      this.alarmRuleModel = 'view';
      this.alarmRuleVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      this.searchForm.warehouseId = '';
      this.warehouseList = [];
      getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
        this.warehouseList = res.data;
      });
      let self = this;
      this.nursinghomeIdList.forEach((ele) => {
        if (nursinghomeId === ele.id) {
          self.searchForm.nursinghomeName = ele.name;
        }
      });
      // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.nursinghomeId);
      // this.getCanteen(this.searchForm.nursinghomeId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          this.$set(this.searchForm, 'nursinghomeName', this.nursinghomeIdList[0].name);
          // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
          //   this.warehouseList = res.data;
          // });
          console.log('onLoad==============>');
          this.onLoad();
        }
      });
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });

      getDictionary('sex').then((res) => {
        this.sexList = res.data;
      });
      getDictionary('nursinghome_political_features_type').then((res) => {
        this.politicalFeaturesList = res.data;
      });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        smartcardpage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
